'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var parser = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    if (typeof undefined === "function" && undefined.amd) {
      undefined(['exports'], factory);
    } else {
      factory(exports);
    }
  })(commonjsGlobal, function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var BBCode = function () {
      /**
       * @param {Object} codes
       * @param {Object} [options]
       */
      function BBCode(codes, options) {
        _classCallCheck(this, BBCode);
        this.codes = [];
        options = options || {}; // copy options

        for (var optionName in options) {
          if (optionName === 'events') {
            continue;
          }
          this[optionName] = options[optionName];
        }
        this.setCodes(codes);
      }
      /**
       * parse
       *
       * @param {String} text
       * @returns {String}
       */

      _createClass(BBCode, [{
        key: 'parse',
        value: function parse(text) {
          return this.codes.reduce(function (text, code) {
            return text.replace(code.regexp, code.replacement);
          }, text);
        }
      }, {
        key: 'add',
        value: function add(regex, replacement) {
          this.codes.push({
            regexp: new RegExp(regex, 'igm'),
            replacement: replacement
          });
          return this;
        }
      }, {
        key: 'setCodes',
        value: function setCodes(codes) {
          this.codes = Object.keys(codes).map(function (regex) {
            var replacement = codes[regex];
            return {
              regexp: new RegExp(regex, 'igm'),
              replacement: replacement
            };
          }, this);
          return this;
        }
      }]);
      return BBCode;
    }(); // create the Default

    var bbCodeParser = new BBCode({
      '\\[br\\]': '<br>',
      '\\[b\\](.+?)\\[/b\\]': '<strong>$1</strong>',
      '\\[i\\](.+?)\\[/i\\]': '<em>$1</em>',
      '\\[u\\](.+?)\\[/u\\]': '<u>$1</u>',
      '\\[h1\\](.+?)\\[/h1\\]': '<h1><a href="$1" name="$1">$1</a></h1>',
      '\\[h2\\](.+?)\\[/h2\\]': '<h2><a href="$1" name="$1">$1</a></h2>',
      '\\[h3\\](.+?)\\[/h3\\]': '<h3><a href="$1" name="$1">$1</a></h3>',
      '\\[h4\\](.+?)\\[/h4\\]': '<h4><a href="$1" name="$1">$1</a></h4>',
      '\\[h5\\](.+?)\\[/h5\\]': '<h5><a href="$1" name="$1">$1</a></h5>',
      '\\[h6\\](.+?)\\[/h6\\]': '<h6><a href="$1" name="$1">$1</a></h6>',
      '\\[p\\](.+?)\\[/p\\]': '<p>$1</p>',
      '\\[color=(.+?)\\](.+?)\\[/color\\]': '<span style="color:$1">$2</span>',
      '\\[size=([0-9]+)\\](.+?)\\[/size\\]': '<span style="font-size:$1px">$2</span>',
      '\\[img\\](.+?)\\[/img\\]': '<img src="$1">',
      '\\[img=(.+?)\\]': '<img src="$1">',
      '\\[email\\](.+?)\\[/email\\]': '<a href="mailto:$1">$1</a>',
      '\\[email=(.+?)\\](.+?)\\[/email\\]': '<a href="mailto:$1">$2</a>',
      '\\[url\\](.+?)\\[/url\\]': '<a href="$1">$1</a>',
      '\\[url=(.+?)\\|onclick\\](.+?)\[/url\]': '<a onclick="$1">$2</a>',
      '\\[url=(.+?)\starget=(.+?)\\](.+)\[/url\]': '<a href="$1" target="$2">$3</a>',
      '\\[url=(.+)\\](.+?)\\[/url\\]': '<a href="$1">$2</a>',
      '\\[a=(.+)\\](.+?)\\[/a\\]': '<a href="$1" name="$1">$2</a>',
      '\\[list\\](.+?)\\[/list\\]': '<ul>$1</ul>',
      '\\[\*\\](.+?)\\[/\\*\\]': '<li>$1</li>'
    }); // define configuration function for default

    bbCodeParser.create = BBCode;
    exports.default = bbCodeParser;
  });
});
var bbCodeParser = unwrapExports(parser);
var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var BBCodeWrapper = styled.span.withConfig({
  displayName: "BBCode__BBCodeWrapper",
  componentId: "sgcv27-0"
})(["margin:", ";a{color:", ";text-decoration:none;&:hover,&:focus{color:", ";}}strong{font-weight:normal;font-family:", ";}"], function (props) {
  return props.margin;
}, colors.BlueSky, colors.BlueDawn, function (_ref) {
  var theme = _ref.theme;
  return getFont(theme, 'bold');
}); // function to safely return the inner-HTML to avoid XSS-attacks.
// more info: https://facebook.github.io/react/tips/dangerously-set-inner-html.html

function createMarkup(label) {
  return {
    __html: label
  };
} // Add your own rules as regex

var defaultParser = {
  '\\[br\\]': '<br>',
  '\\[b\\](.+?)\\[/b\\]': '<strong>$1</strong>',
  '\\[i\\](.+?)\\[/i\\]': '<em>$1</em>',
  '\\[u\\](.+?)\\[/u\\]': '<u>$1</u>',
  '\\[h1\\](.+?)\\[/h1\\]': '<h1>$1</h1>',
  '\\[h2\\](.+?)\\[/h2\\]': '<h2>$1</h2>',
  '\\[h3\\](.+?)\\[/h3\\]': '<h3>$1</h3>',
  '\\[h4\\](.+?)\\[/h4\\]': '<h4>$1</h4>',
  '\\[h5\\](.+?)\\[/h5\\]': '<h5>$1</h5>',
  '\\[h6\\](.+?)\\[/h6\\]': '<h6>$1</h6>',
  '\\[p\\](.+?)\\[/p\\]': '<p>$1</p>',
  '\\[color=(.+?)\\](.+?)\\[/color\\]': '<span style="color:$1">$2</span>',
  '\\[size=([0-9]+)\\](.+?)\\[/size\\]': '<span style="font-size:$1px">$2</span>',
  '\\[img\\](.+?)\\[/img\\]': '<img src="$1">',
  '\\[img=(.+?)\\]': '<img src="$1">',
  '\\[email\\](.+?)\\[/email\\]': '<a href="mailto:$1">$1</a>',
  '\\[email=(.+?)\\](.+?)\\[/email\\]': '<a href="mailto:$1">$2</a>',
  '\\[url\\](.+?)\\[/url\\]': '<a href="$1">$1</a>',
  '\\[url=(.+?)\\|onclick\\](.+?)\\[/url\\]': '<a onclick="$1">$2</a>',
  '\\[url=(.+?)\\starget=(.+?)\\](.+?)\\[/url\\]': '<a href="$1" target="$2">$3</a>',
  '\\[url=(.+?)\\](.+?)\\[/url\\]': '<a href="$1">$2</a>',
  '\\[a=(.+?)\\](.+?)\\[/a\\]': '<a href="$1" name="$1">$2</a>',
  '\\[list\\](.+?)\\[/list\\]': '<ul>$1</ul>',
  '\\[\\*\\](.+?)\\[/\\*\\]': '<li>$1</li>',
  '\\[sup\\](.+?)\\[/sup\\]': '<sup>$1</sup>'
};
var BBCode = function BBCode(props) {
  bbCodeParser.create(props.parser || defaultParser);
  return props.children ? /*#__PURE__*/React.createElement(BBCodeWrapper, {
    className: props.className,
    dangerouslySetInnerHTML: createMarkup(bbCodeParser.parse(props.children)),
    margin: props.margin
  }) : null;
};
exports.BBCode = BBCode;